import { createNamedContext } from '@utils';

type PrivacyConsentState = [number, () => void];

export const PrivacyConsentContext = createNamedContext<PrivacyConsentState | undefined>(undefined, 'PrivacyConsentContext');